import React from "react";
/**
 * Se importa jquery
 */
import jQuery from "jquery";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;

/**
 * Componente que representa el formulario de alta y modificación de un
 * recurso.
 */
export class Tabs extends React.Component {
  el = React.createRef();
  componentDidMount() {
    this.initTab();
  }

  initTab() {
    jQuery("[data-tab-item]:first").addClass("is-active");
    jQuery("[data-tab-content]:first").addClass("is-active");

    jQuery(this.el)
      .find("[data-tab-item]")
      .on("click", function() {
        var tab = jQuery(this).attr("data-tab-item");
        jQuery(this)
          .parent()
          .find("[data-tab-item]")
          .removeClass("is-active");
        jQuery("[data-tab-content]").removeClass("is-active");

        jQuery(this).addClass("is-active");
        jQuery('[data-tab-content="' + tab + '"]').addClass("is-active");
      });
  }

  render() {
    return (
      <div className="tabs" ref={ref => (this.el = jQuery(ref))}>
        <ul>{this.props.children}</ul>
      </div>
    );
  }
}

export class TabItem extends React.Component {
  render() {
    return (
      <li data-tab-item={this.props.name}>
        <a>{this.props.children}</a>
      </li>
    );
  }
}

export class TabContent extends React.Component {
  render() {
    return <div data-tab-content={this.props.name}>{this.props.children}</div>;
  }
}
